<template>
	<div>
		<template v-if="dataList.length">			
			<van-list
				v-model="loading"	
				:finished="finished"
				:immediate-check="false"
				finished-text="没有更多了"
				@load="onLoad"
				:offset="10"
			>
				<div class="friendsList">
					<template v-for="(item, index) in dataList">					
						<div @click="toDetail(item.id)" v-if="item.type == 2" :key="item.id" class="friendsItem flex" >
							<img :src="item.avatar" class="avatar" />
							<div class="right flex-1 flex flex-column">
								<div class="name">{{item.nickname}}</div>
								<div class="time">{{item.time}}</div>
								<div class="content">{{item.brief}}</div>
								<div class="imgList flex flex-align-center flex-jus-between flex-wrap">
									<videoItem :content="''" :width="167" :height="111" :videoSrc="item.content"></videoItem>
								</div>

								<div class="infoStatus flex flex-row-reverse">
									<div class="flex flex-align-center">
										<img src="@/static/images/my/message.png" class="icon" />
										<div>{{item.comment_num}}</div>
									</div>

									<div class="flex flex-align-center" style="margin-right: 20px;">
										<img v-if="item.is_likes == 1" @click.stop="doLikes(item.id,index)" src="../../static/images/index/good_yes.png" class="icon" />
										<img v-else @click.stop="doLikes(item.id,index)" src="../../static/images/index/good.png" class="icon" />
										<div>{{item.likes_num}}</div>
									</div>
								</div>
							</div>
						</div>
						<div @click="toDetail(item.id)" v-if="item.type == 1" :key="item.id" class="friendsItem flex">
							<img :src="item.avatar" class="avatar" />
							<div class="right flex-1 flex flex-column">
								<div class="name">{{item.nickname}}</div>
								<div class="time">{{item.time}}</div>
								<div class="content">{{item.brief}}</div>
								<div class="imgList flex flex-align-center flex-jus-between flex-wrap">
									<img v-for="(cItem, cIndex) in item.content" :key="cIndex" :src="cItem" alt="" />
								</div>

								<div class="infoStatus flex flex-row-reverse">
									<div class="flex flex-align-center">
										<img src="@/static/images/my/message.png" class="icon" />
										<div>{{item.comment_num}}</div>
									</div>

									<div class="flex flex-align-center" style="margin-right: 20px;">
										<img v-if="item.is_likes == 1" @click.stop="doLikes(item.id, index)" src="../../static/images/index/good_yes.png" class="icon" />
										<img v-else @click.stop="doLikes(item.id, index)" src="../../static/images/index/good.png" class="icon" />
										<div>{{item.likes_num}}</div>
									</div>
								</div>
							</div>
						</div>
					</template>
				</div>
			</van-list>
		</template>
		<template v-else>
			<div class="empty">
				<div class="empty-img">
					<img src="@/static/images/index/emptySearch.png" alt="">
				</div>
				<div class="empty-text">暂无相关友圈</div>
			</div>
		</template>
	</div>
</template>

<script>
import videoItem from '@/views/components/videoItem.vue';
/* eslint-disable */
export default {
	components: {
		videoItem
	},
	data() {
		return {
			page: 1,
			loading: false,
      finished: false,
      dataList: []
		};
	},
	props: {
    search_text: {
      type: String,
      default: ''
    }
  },
	methods: {
		getList(page = 0) {
			this.$get('api/index/search', {
				type: 5,
				search_text: this.search_text,
				pageSize: 10,
				page: page || this.page
			}).then(res => {
				this.loading = false;
        let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
				let num = page || this.page
				this.dataList.splice((num - 1)*10, 10, ...rows)
			})
		},
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getList();
      }
		},
		doLikes(id, index) {
			this.$post('api/actile/doLikes', {
				type: 2,
				article_id: id
			}).then(() => {
				this.getList(Math.ceil(index / 10))
			})
		},
		toDetail(id) {
			this.$router.push({name: 'circleDetail', query: {id}})
		}
	}
};
</script>

<style scoped lang="stylus">
.friendsList
	padding 0 30px
	.friendsItem
		padding-top 44px
		.avatar
			width 84px
			height 84px
			border-radius 50%
		.name
			width 100%
			font-size 28px
			font-weight bold
			color #000000
		.time
			width 100%
			margin-top 8px
			font-size 22px
			color #979797
		.content
			margin-top 24px
			margin-bottom 28px
			width 100%
			font-size 26px
			color #000000
		.imgList
			img
				width 186px
				height 186px
				object-fit cover
				border-radius 20px
				margin-bottom 10px
		.imgList:after
			content ''
			display inline-block
			width 186px
			height 186px
		.right
			margin-left 24px
			border-bottom 2px solid #ECECEC
		.infoStatus
			margin-top 40px
			margin-bottom 40px
			font-size 26px
			color #000000
			.icon
				width 32px
				height 32px
				margin-right 8px
.empty
	background-color inherit
	.empty-img
		margin 280px auto 0 auto
		width 373px
		height 320px
		img
			width 100%
			height 100%
	.empty-text
		width 100%
		text-align center
		margin-top 22px
		font-size: 26px;
		color: #111111;
</style>
